import { MockConfigData } from "./MockData";

export function setupConfigMock(mock) {
  mock.onGet("/login/config").reply(200, MockConfigData);
}
